module.exports = __webpack_public_path__ + "static/projectLiquality-11d4b6d38dc179fb6355c4edf2ea7e48.png";